import { Badge } from '@winnin/winnin_ui.components.badge'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

const LIVE_BADGE_TRANSLATION = {
  inProgress: TOLGEE_GLOBALS.live,
  scheduled: TOLGEE_GLOBALS.upcoming,
  finished: TOLGEE_GLOBALS.liveEnded,
}
const BADGE_COLOR_SCHEME = {
  inProgress: 'primary',
  scheduled: 'gray',
  finished: 'gray',
}

function LivePostTag({ live, isCard = true }) {
  if (!live || (isCard && live?.state === 'finished')) {
    return null
  }

  const badgeTranslation = LIVE_BADGE_TRANSLATION?.[live?.state]
  const badgeColorScheme = BADGE_COLOR_SCHEME?.[live?.state]

  return (
    <Badge className="LivePostTag" colorScheme={badgeColorScheme}>
      <T keyName={badgeTranslation.key}>{badgeTranslation.defaultValue}</T>
    </Badge>
  )
}

export default LivePostTag
